<template>
  <div>
    <loading
      :active.sync="fullscreenLoading"
      :can-cancel="false"
      :on-cancel="onCancel"
      :is-full-page="true"
      :color="loadingColor"
      :height="loadingHeight"
      :width="loadingWidth"
    ></loading>
    <!-- CABECERA:-->
    <base-header class="pb-4">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">
            {{ totalActivos }} Retirados
          </h6>
        </div>
        <div class="col-lg-6 col-5 text-right">
          <base-button
            size="sm"
            type="neutral"
            @click="clearSearchState"
            :loading="loading"
            >Limpiar filtros</base-button
          >
          <!-- <base-button
            size="sm"
            type="neutral"
            @click="fetchDataAndExportToExcel()"
            :loading="loading"
            >Exportar a Excel</base-button
          > -->
        </div>
      </div>
      <!-- CARDS CON LOS ESTADOS DE LOS EQUIPOS:-->
      <div class="kpi-container">
        <!-- No Aptos -->
        <div
          class="kpi-item"
          @click="getList('No apto')"
          style="cursor: pointer"
        >
          <stats-card-img
            title="No aptos"
            type="gradient-red"
            :sub-title="totalNoAptos ? totalNoAptos.toString() : '0'"
            img="/img/ios-alert.png"
          >
            <template slot="footer">
              <span class="text-success mr-2"
                >{{
                  totalNoAptos
                    ? Math.floor((totalNoAptos * 100) / totalActivos)
                    : "0"
                }}%</span
              >
              <span class="text-nowrap">de los equipos</span>
            </template>
          </stats-card-img>
        </div>

        <!-- Caducados -->
        <div
          class="kpi-item"
          @click="getList('Caducado')"
          style="cursor: pointer"
        >
          <stats-card-img
            title="Revisión caducada"
            type="gradient-orange"
            :sub-title="totalCaducados ? totalCaducados.toString() : '0'"
            img="/img/ios-time.png"
          >
            <template slot="footer">
              <span class="text-success mr-2"
                >{{
                  totalCaducados
                    ? Math.floor((totalCaducados * 100) / totalActivos)
                    : "0"
                }}%</span
              >
              <span class="text-nowrap">de los equipos</span>
            </template>
          </stats-card-img>
        </div>

        <!-- Revisión Próxima -->
        <div
          class="kpi-item"
          @click="getList('Prox_Rev')"
          style="cursor: pointer"
        >
          <stats-card-img
            title="Revisión próxima"
            type="gradient-green"
            :sub-title="totalCaducan ? totalCaducan.toString() : '0'"
            img="/img/ios-time-blue.png"
          >
            <template slot="footer">
              <span class="text-success mr-2"
                >{{
                  totalCaducan
                    ? Math.floor((totalCaducan * 100) / totalActivos)
                    : "0"
                }}%</span
              >
              <span class="text-nowrap">en 3 meses</span>
            </template>
          </stats-card-img>
        </div>

        <!-- Aptos a Vigilar -->
        <div
          class="kpi-item"
          @click="getList('Apto a vigilar')"
          style="cursor: pointer"
        >
          <stats-card-img
            title="Aptos a vigilar"
            type="gradient-red"
            :sub-title="
              totalAptosAVigilar ? totalAptosAVigilar.toString() : '0'
            "
            img="/img/ios-checkmark-orange.png"
          >
            <template slot="footer">
              <span class="text-success mr-2"
                >{{
                  totalAptosAVigilar
                    ? Math.floor((totalAptosAVigilar * 100) / totalActivos)
                    : "0"
                }}%</span
              >
              <span class="text-nowrap">de los equipos</span>
            </template>
          </stats-card-img>
        </div>

        <!-- Aptos -->
        <div class="kpi-item" @click="getList('Apto')" style="cursor: pointer">
          <stats-card-img
            title="Aptos"
            type="gradient-green"
            :sub-title="totalAptos ? totalAptos.toString() : '0'"
            img="/img/ios-checkmark-circle.png"
          >
            <template slot="footer">
              <span class="text-success mr-2"
                >{{
                  totalAptos
                    ? Math.floor((totalAptos * 100) / totalActivos)
                    : "0"
                }}%</span
              >
              <span class="text-nowrap">de los equipos</span>
            </template>
          </stats-card-img>
        </div>
      </div>

      <div class="row align-items-center">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0"></h6>
        </div>
        <div class="col-lg-6 col-5 text-right">
          <base-button
            size="sm"
            type="neutral"
            @click="reactivar()"
            v-if="multipleSelection.length > 0"
          >
            Reactivar equipos
          </base-button>
          <!-- Nuevo botón: Exportar seleccionados -->
          <!-- <base-button
            size="sm"
            type="neutral"
            @click="fetchSelectedAndExportToExcel"
            v-if="multipleSelection.length > 0"
            :loading="loading"
          >
            Exportar seleccionados
          </base-button> -->
        </div>
      </div>
    </base-header>

    <!-- CONTENIDO:-->
    <div class="container-fluid mt--4" v-if="fullscreenLoading == false">
      <card
        class="no-border-card"
        body-classes="px-0 pb-1"
        footer-classes="pb-2"
      >
        <div class="p-2">
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            :class="{
              'has-active-filters':
                !!query || !!estado || !!fdesde || !!fhasta,
            }"
          >
            <!-- BUSCADOR:-->
            <div class="col-md-4">
              <div :class="{ 'has-filter': !!query }">
                <form @submit.prevent>
                  <base-input
                    v-model="query"
                    type="search"
                    prepend-icon="fas fa-search"
                    placeholder="Buscar por marca, modelo, nº serie, usuario..."
                    clearable
                  />
                </form>
              </div>
            </div>
            <!-- FILTROS:-->
            <div class="col-md-8">
              <div class="d-flex justify-content-right justify-content-sm-end">
                <div class="pr-4" :class="{ 'has-filter': !!estado }">
                  <el-select
                    class="select-primary pagination-select"
                    :class="{ 'is-selected': hasSelectedValue }"
                    v-model="estado"
                    placeholder="Estado"
                    style="width: 100%; height: 46px !important"
                    @change="handleStateChange"
                  >
                    <el-option
                      class="select-primary"
                      v-for="item in estados"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div>
                  <div class="row">
                    <div class="col pr-1" :class="{ 'has-filter': !!fdesde }">
                      <base-input label="">
                        <flat-picker
                          slot-scope="{ focus, blur }"
                          @on-open="focus"
                          @on-close="blur"
                          :config="configInput"
                          class="form-control datepicker"
                          v-model="fdesde"
                          placeholder="Prox. revisión desde..."
                        >
                        </flat-picker>
                      </base-input>
                    </div>
                    <div class="col pl-0" :class="{ 'has-filter': !!fhasta }">
                      <base-input label="">
                        <flat-picker
                          slot-scope="{ focus, blur }"
                          @on-open="focus"
                          @on-close="blur"
                          :config="configInput"
                          class="form-control datepicker"
                          v-model="fhasta"
                          placeholder="Prox. revisión hasta..."
                        >
                        </flat-picker>
                      </base-input>
                    </div>
                  </div>
                </div>
                <div
                  class="ml-2 d-flex align-items-center"
                  v-if="hasActiveFilters"
                >
                  <button
                    class="btn clear-filters-btn"
                    @click="clearSearchState"
                    title="Limpiar filtros"
                  >
                    <i class="fas fa-times-circle"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- TABLA DE EQUIPOS:-->
          <el-table
            ref="multipleTable"
            class="table-responsive align-items-center table-flush all-retired"
            header-row-class-name="thead-light"
            :data="activos"
            @sort-change="sortChange"
            @selection-change="handleSelectionChange"
            empty-text="No hay ningún equipo que cumpla con los requisitos de búsqueda"
            :row-class-name="getRowClass"
          >
            <!-- LOADING-->
            <div slot="empty" v-if="loadingTable">
              <img src="/img/loading.gif" style="height: 100px; width: 100px" />
            </div>

            <el-table-column type="selection" width="40"> </el-table-column>
            <!--  <el-table-column
                  label="CATEGORIA"
                  prop="subtipo.data.attributes.nombre"
                  sortable="custom"
                  :min-width="60"
                /> -->
            <!--   <el-table-column
              label="CATEGORIA"
              prop="subtipo.data.attributes.nombre"
              sortable="custom"
              :min-width="100"
            >
            </el-table-column> -->

            <!--  <el-table-column
                  label="Marca"
                  prop="fabricante.data.attributes.nombre"
                  sortable="custom"
                  :min-width="60"
                /> -->

            <!-- COLUMNA MODELO -->
            <el-table-column
              label="Modelo"
              prop="modelo.data.attributes.nombre"
              sortable="custom"
              :min-width="180"
              :max-width="220"
            >
              <template v-slot="{ row }">
                {{ row.modelo.data.attributes.nombre + "-" }}
                <b>{{ row.fabricante.data.attributes.nombre }}</b>
              </template>
            </el-table-column>
            <!-- COLUMNA NUMERO SERIE -->
            <el-table-column
              label="Nº serie"
              prop="numero_serie"
              sortable="custom"
              :min-width="80"
              :max-width="100"
            >
              <template v-slot="{ row }">
                <b>{{ row.numero_serie }}</b>
              </template>
            </el-table-column>

            <el-table-column
              label=""
              :min-width="50"
              :max-width="60"
              justify-content-center
            >
              <template v-slot="{ row }">
                <!-- TODOS LOS EQUIPOS ESTÁN RETIRADOS EN ESTA VISTA -->
                <div class="retired-icon text-center">
                  <i
                    class="fas fa-archive"
                    style="color: #666; font-size: 16px"
                  ></i>

                  <small class="badge badge-retired no-strike">RETIRADO</small>
                </div>
              </template>
            </el-table-column>

            <!--   <el-table-column
                  label="Prox. Revisión"
                  prop="fecha_prox_revision"
                  sortable="custom"
                  :min-width="130"
                >
                  <template slot-scope="{ row }">
                    <badge class="badge-dot mr-4" type="">
                      <i
                        v-if="
                          moment(row.fecha_prox_revision).isSameOrAfter(
                            new Date().getTime()
                          )
                        "
                        class="`bg-success`"
                      ></i>
                      <i
                        v-if="
                          moment(row.fecha_prox_revision).isBefore(
                            new Date().getTime()
                          )
                        "
                        class="`bg-warning`"
                      ></i>
                      <span class="status"
                        >{{
                          moment(row.fecha_prox_revision).format("DD/MM/YYYY")
                        }}
                        ({{ moment(row.fecha_prox_revision).fromNow() }})</span
                      >
                    </badge>
                  </template>
                </el-table-column> -->

            <el-table-column
              label="Prox. Revisión"
              prop="fecha_prox_revision"
              sortable="custom"
              align="left"
              :min-width="120"
              :max-width="140"
            >
              <template v-slot="{ row }">
                <badge class="badge-dot">
                  <i
                    v-if="
                      moment(row.fecha_prox_revision).isBefore(
                        new Date().getTime()
                      )
                    "
                    class="bg-danger"
                  ></i>
                  <i
                    v-else-if="
                      moment()
                        .add(3, 'months')
                        .isSameOrAfter(moment(row.fecha_prox_revision))
                    "
                    class="bg-warning"
                  ></i>
                  <i
                    v-else-if="
                      moment(row.fecha_prox_revision).isSameOrAfter(
                        new Date().getTime()
                      )
                    "
                    class="bg-success"
                  ></i>
                </badge>
                <span class="status"
                  >{{ moment(row.fecha_prox_revision).format("DD/MM/YYYY")
                  }}<br />
                  ({{ moment(row.fecha_prox_revision).fromNow() }})</span
                >
              </template>
            </el-table-column>

            <!-- <el-table-column
                  label="Planta"
                  prop="empresa.data.attributes.alias"
                  sortable="custom"
                  :min-width="90"
                /> -->

            <el-table-column
              label="QR"
              prop="numero_serie"
              sortable="custom"
              :min-width="60"
              :max-width="80"
            >
              <template v-slot="{ row }">
                <b>{{ row.numero_serie_qr }}</b>
              </template>
            </el-table-column>
            <el-table-column
              label="Usuario"
              sortable="custom"
              :min-width="120"
              :max-width="160"
            >
              <template v-slot="{ row }">
                <a
                  v-if="row.usuario.data"
                  :href="'/user-management/edit-user/' + row.usuario.data.id"
                  class="font-weight-bold"
                >
                  <b>{{
                    row.usuario.data
                      ? row.usuario.data.attributes.nombre +
                        " " +
                        row.usuario.data.attributes.apellidos
                      : ""
                  }}</b></a
                >
              </template>
            </el-table-column>
            <el-table-column
              label="Acciones"
              align="center"
              :min-width="70"
              :max-width="90"
            >
              <div slot-scope="{ row }" class="table-actions">
                <el-tooltip content="Ver equipo" placement="top">
                  <a
                    type="text"
                    @click="viewTipo(row)"
                    class="table-action"
                    data-toggle="tooltip"
                    style="cursor: pointer; margin-right: 8px"
                  >
                    <i
                      class="fas fa-eye"
                      style="color: #5e72e4; font-size: 16px"
                    ></i>
                  </a>
                </el-tooltip>

                <!-- Devolver button hidden as requested -->
                <!-- <el-tooltip
                  content="Devolver equipo"
                  placement="top"
                  v-if="row.usuario.data"
                >
                  <a
                    type="text"
                    @click="desAssignOnlyOnePost(row)"
                    class="table-action"
                    data-toggle="tooltip"
                    style="cursor: pointer"
                  >
                    <i
                      class="fas fa-undo"
                      style="color: #f5365c; font-size: 16px"
                    ></i>
                  </a>
                </el-tooltip> -->

                <!-- Botones originales comentados -->
                <!-- <base-button
                  outline
                  size="sm"
                  type="primary"
                  @click="viewTipo(row)"
                  style="padding-left: 10px; padding-right: 10px"
                  >Ver</base-button
                >
                <base-button
                  v-if="row.usuario.data"
                  outline
                  size="sm"
                  type="danger"
                  @click="desAssignOnlyOnePost(row)"
                  style="padding-left: 10px; padding-right: 10px"
                  >Devolver</base-button
                > -->
              </div>
            </el-table-column>
          </el-table>
        </div>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div class="row">
            <div class="col-xl-4">
              <el-select
                class="select-primary pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </div>

            <div class="col-xl-8">
              <p class="card-category" style="margin-top: 0.5rem">
                Mostrando {{ total ? from + 1 : 0 }} - {{ to }} de
                {{ total }} registros

                <span v-if="selectedRows.length">
                  &nbsp; &nbsp; {{ selectedRows.length }} rows selected
                </span>
              </p>
            </div>
          </div>

          <base-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          />
        </div>
      </card>
    </div>
    <!-- DIALOG ASIGNACIÓN EQUIPOS -->
    <el-dialog
      title="Asignación de equipos"
      :visible.sync="dialogFormVisible"
      width="60%"
    >
      <div class="col-auto">
        <p>Selecciona el usuario al que quieres asignar los equipos:</p>
        <el-select
          style="width: 100%"
          size="large"
          name="revisor"
          v-model="usuarioSeleccionado"
          placeholder="Selecciona el usuario..."
          filterable
        >
          <el-option
            v-for="revisor in available_revisores"
            :key="revisor.id"
            :value="revisor.id"
            :label="revisor.nombre"
          >
          </el-option>
        </el-select>
      </div>

      <span slot="footer" class="dialog-footer">
        <base-button @click="dialogFormVisible = false" type="secondary"
          >Cancelar</base-button
        >

        <base-button
          v-if="usuarioSeleccionado"
          @click="assignPost"
          type="primary"
          >Confirmar</base-button
        >
      </span>
    </el-dialog>

    <!-- DIALOG SOLICITUD REVISIÓN -->
    <el-dialog
      title="Solicitar revisión a Misepis"
      :visible.sync="dialogFormVisibleRev"
      width="60%"
    >
      <div class="col-auto">
        <p>
          Si aceptas se enviará una solicitud para realizar una revisión de los
          equipos seleccionados:
        </p>
        <ul>
          <li
            v-for="equipo in this.multipleSelection"
            :key="equipo.id"
            :value="equipo.id"
          >
            Identificador: <b>{{ equipo.nombre }}</b
            >. Número de serie:
            <b>{{ equipo.numero_serie }}</b>
          </li>
        </ul>
      </div>

      <span slot="footer" class="dialog-footer">
        <base-button @click="dialogFormVisibleRev = false" type="secondary"
          >Cancelar</base-button
        >

        <base-button @click="revisionPost" type="primary">Aceptar</base-button>
      </span>
    </el-dialog>

    <!-- DIALOG RETIRAR EQUIPOS -->
    <el-dialog
      title="Retirar equipos"
      :visible.sync="dialogFormVisibleRetirar"
      width="60%"
    >
      <div class="col-auto">
        <p>
          ¿Estas seguro? Los equipos seleccionados se reactivarán a la
          circulación y volverán a ser visibles.
        </p>
        <ul>
          <li
            v-for="equipo in this.multipleSelection"
            :key="equipo.id"
            :value="equipo.id"
          >
            Identificador: <b>{{ equipo.nombre }}</b
            >. Número de serie:
            <b>{{ equipo.numero_serie }}</b>
          </li>
        </ul>
      </div>

      <span slot="footer" class="dialog-footer">
        <base-button @click="dialogFormVisibleRetirar = false" type="secondary"
          >Cancelar</base-button
        >

        <base-button @click="reactivarPost" type="primary"
          >Reactivar</base-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { BasePagination } from "@/components/";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import {
  Table,
  TableColumn,
  Dialog,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  RadioButton,
  Button,
  // Loading
} from "element-ui";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import moment from "moment";
import "moment/locale/es"; // without this line it didn't work
import { cloneDeep } from "lodash";
import axios from "axios";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
moment.locale("es");

import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Spanish } from "flatpickr/dist/l10n/es.js";

import VueJsonToCsv from "vue-json-to-csv";

export default {
  layout: "DashboardLayout",

  components: {
    BasePagination,
    flatPicker,
    Loading,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dialog.name]: Dialog,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
  },

  data() {
    return {
      query: null,
      activos: [],
      selectedRows: [],
      sort: "fecha_prox_revision",

      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [25, 50, 100, 200],
      },
      multipleSelection: [],
      totalAssigned: 0,
      total: 0,
      loading: false,
      loadingTable: true,
      fullscreenLoading: false,
      loadingColor: "#7f1058",
      loadingBgColor: "#000",
      loadingHeight: 128,
      loadingWidth: 128,
      dialogFormVisible: false,
      dialogFormVisibleRev: false,
      dialogConfirmVisible: false,
      dialogFormVisibleRetirar: false,
      innerVisible: false,
      formLabelWidth: "120px",
      available_revisores: [],
      usuarioSeleccionado: null,
      fdesde: null,
      fhasta: null,
      estado: null,
      usuario: null,
      estados: [
        "Apto",
        "Apto a vigilar",
        "No apto",
        "Caducado",
        "Con incidencia",
        "Todos",
      ],
      dashboardQuery: false,
      hasSelectedValue: false,
      totalNoAptos: 0,
      totalAptosAVigilar: 0,
      totalIncidencia: 0,
      totalCaducados: 0,
      totalCaducan: 0,
      totalAptos: 0,
      totalActivos: 0,
      configInput: {
        allowInput: true,
        dateFormat: "d-m-Y",
        locale: Spanish, // locale for this instance only
      },
      itemsToExport: [],

      labels: {
        /* "subtipo.data.attributes.nombre": { title: "Subtipo" }, */
        "fabricante.data.attributes.nombre": { title: "Fabricante" },
        numero_serie: { title: "Nº serie" },
        fecha_prox_revision: { title: "Prox. Revisión" },
        "empresa.data.attributes.alias": { title: "Planta" },
        nombre: { title: "Nombre" },
        descripcion: { title: "Descripción" },
      },
      notificacion: {
        type: "notificaciones",
        descripcion: null,
        estado_notificacion: {
          id: 1, //pendiente de enviar
        },
        tipo_notificacion: {
          id: 3, //tipo: revision
        },
        usuario_origen: {
          id: null,
        },
        usuario_destinos: [],
        empresa: {
          id: null,
        },
        activos: {},
      },
    };
  },
  created() {
    this.getRevisores();
  },
  mounted() {
    const savedState = localStorage.getItem("retiradosSearchState");

    if (savedState) {
      const state = JSON.parse(savedState);
      this.query = state.query || null;
      this.fdesde = state.fdesde || null;
      this.fhasta = state.fhasta || null;
      this.estado = state.estado || null;
      this.pagination.currentPage = state.currentPage || 1;
      this.pagination.perPage = state.perPage || 25;
      this.multipleSelection = state.selectedRows || [];
      this.hasSelectedValue = !!this.estado;
      this.getList();
    } else if (this.$route.query.filter) {
      this.getList(this.$route.query.filter);
      this.dashboardQuery = true;
    }
  },
  computed: {
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    plantaSelected() {
      return this.$plantaSelected;
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    hasActiveFilters() {
      return !!(this.query || this.estado || this.fdesde || this.fhasta);
    },
  },

  watch: {
    query: {
      handler: "handleQueryChange",
      immediate: true,
    },
    fdesde: {
      handler: "getListDebounced",
      immediate: true,
    },
    fhasta: {
      handler: "getListDebounced",
      immediate: true,
    },
    estado: {
      handler: "getListDebounced",
      immediate: true,
    },
    pagination: {
      handler: "getList",
      immediate: false,
      deep: true,
    },
  },

  methods: {
    onCancel() {
      console.log("User cancelled the loader.");
    },
    
    // Extraer identificador de una URL (último segmento después del último /)
    extractIdentifierFromUrl(input) {
      if (!input) return input;
      
      // Si es una URL de misepis.com/code/, extraer el código después de code/
      if (input.includes('misepis.com/code/')) {
        const codeMatch = input.split('code/').pop().split('/')[0];
        if (codeMatch) {
          console.log(`URL misepis.com detectada: ${input} -> Código extraído: ${codeMatch}`);
          return codeMatch;
        }
      }
      
      // Si es una URL de ssea.es/, extraer el código después de ssea.es/
      if (input.includes('ssea.es/')) {
        const codeMatch = input.split('ssea.es/').pop().split('/')[0];
        if (codeMatch) {
          console.log(`URL ssea.es detectada: ${input} -> Código extraído: ${codeMatch}`);
          return codeMatch;
        }
      }
      
      // Verificar si es una URL (contiene http, https, o múltiples /)
      if (input.includes('http') || input.split('/').length > 2) {
        // Extraer el último segmento después del último /
        const segments = input.split('/');
        const lastSegment = segments[segments.length - 1];
        
        // Si el último segmento está vacío, tomar el penúltimo
        const identifier = lastSegment || segments[segments.length - 2];
        
        console.log(`URL detectada: ${input} -> Identificador extraído: ${identifier}`);
        return identifier;
      }
      
      return input;
    },
    
    // Manejar cambios en el query, procesando URLs si es necesario
    handleQueryChange() {
      if (this.query) {
        const processedQuery = this.extractIdentifierFromUrl(this.query);
        if (processedQuery !== this.query) {
          // Si se procesó una URL, actualizar el query con el identificador extraído
          this.query = processedQuery;
          return; // No llamar a getListDebounced aquí para evitar doble llamada
        }
      }
      this.getListDebounced();
    },
    checkIdRevisor(id) {
      return this.available_revisores.some(function (gfg) {
        return gfg.id === id;
      });
    },
    assign() {
      this.dialogFormVisible = true;
    },
    reactivar() {
      this.dialogFormVisibleRetirar = true;
    },
    revision() {
      this.dialogFormVisibleRev = true;
    },

    async assignPost() {
      this.fullscreenLoading = true;
      for (const element of this.multipleSelection) {
        var el = element;
        el.usuario = this.usuarioSeleccionado;
        await this.$store.dispatch("activos/update", el);
      }
      this.dialogFormVisible = false;
      //this.dialogConfirmVisible = true;
      this.showSwal("success");
    },
    async revisionPost() {
      let html_activos = "<ul>";
      for (const activo of this.multipleSelection) {
        html_activos =
          html_activos +
          "<li> Identificador: <b>" +
          activo.nombre +
          "</b>. Número de serie: <b>" +
          activo.numero_serie +
          "</b></li>";
      }
      html_activos = html_activos + "</ul>";

      console.log(html_activos);

      this.notificacion.activos = html_activos;
      // this.notificacion.activos = this.multipleSelection;
      console.log("NOTIFICACIÓN:");
      console.log(this.notificacion);

      try {
        await this.$store.dispatch("notificaciones/add", this.notificacion);
        this.$notify({
          type: "success",
          message: "La solicitud se ha enviado correctamente.",
        });
        this.dialogFormVisibleRev = false;
        //this.$router.go(0);
      } catch (error) {
        console.log(error);
        this.$notify({
          type: "danger",
          message: "Oops, algo ha ido mal",
        });
        this.setApiValidation(error.response.data.error.details.errors);
      }
    },
    async reactivarPost() {
      try {
        this.fullscreenLoading = true;

        // Cerrar el modal antes de realizar las operaciones
        this.dialogFormVisibleRetirar = false;

        // Realizar la operación de retiro para cada elemento seleccionado
        for (const element of this.multipleSelection) {
          var el = element;
          el.retirado = 0;
          await this.$store.dispatch("activos/update", el);
        }

        // Mostrar un mensaje de éxito
        this.showSwal("success");
      } catch (error) {
        console.error("Error al reactivar equipos:", error);
        this.$notify({
          type: "danger",
          message: "Oops, algo ha ido mal al reactivar los equipos.",
        });
      } finally {
        // Asegúrate de que el loader se detenga siempre
        this.fullscreenLoading = false;
      }
    },

    async desAssignPost() {
      this.fullscreenLoading = true;
      for (const element of this.multipleSelection) {
        var el = element;
        el.usuario = null;
        await this.$store.dispatch("activos/update", el);
      }
      this.dialogFormVisible = false;
      //this.dialogConfirmVisible = true;
      this.showSwal("success_devueltos");
    },

    async desAssignOnlyOnePost(el) {
      this.fullscreenLoading = true;

      el.usuario = null;
      await this.$store.dispatch("activos/update", el);

      this.dialogFormVisible = false;
      //this.dialogConfirmVisible = true;
      this.showSwal("success_devueltos");
    },

    checkIfSomeOneIsAssigned() {
      let isAssigned = 0;
      for (const element of this.multipleSelection) {
        console.log(element.usuario.data);
        if (element.usuario.data != null) isAssigned++;
      }
      this.totalAssigned = isAssigned;
    },

    flattenObject(obj) {
      let flattenKeys = {};
      for (let i in obj) {
        if (!obj.hasOwnProperty(i)) continue;
        if (typeof obj[i] == "object") {
          // flattenKeys[i] = obj[i];
          let flatObject = this.flattenObject(obj[i]);
          for (let j in flatObject) {
            if (!flatObject.hasOwnProperty(j)) continue;
            flattenKeys[i + "." + j] = flatObject[j];
          }
        } else {
          flattenKeys[i] = obj[i];
        }
      }
      return flattenKeys;
    },

    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.checkIfSomeOneIsAssigned();
    },

    clearSearchState() {
      localStorage.removeItem("retiradosSearchState");
      this.dashboardQuery = false;
      this.query = null;
      this.fdesde = null;
      this.fhasta = null;
      this.estado = null;
      this.hasSelectedValue = false;
      this.pagination.currentPage = 1;
      this.pagination.perPage = 25;
      this.multipleSelection = [];
      this.getList();
    },

    handleStateChange(value) {
      this.hasSelectedValue = !!value;
    },

    async resolveEmpresas() {
      const planta = localStorage.getItem("plantaSelected");
      await this.$store.dispatch("profile/me");
      const profile = await this.$store.getters["profile/me"];
      const perteneceSalvador = profile.empresas.some(
        (empresa) => empresa.id_cliente_erp === "00001001"
      );
      let empresas = [];

      if (perteneceSalvador && planta === "all") {
        empresas = [];
      } else if (planta >= 0) {
        empresas = [planta];
      } else {
        profile.empresas.forEach((element) => {
          empresas.push(element.id);
        });
      }

      this.notificacion.empresa.id = planta;
      return empresas;
    },

    pushEstadoFilter(filters, estado) {
      if (!estado || estado === "Todos") {
        return;
      }

      switch (estado) {
        case "Apto":
          filters.$and.push({
            revisiones: {
              active: true,
              estado: { $eq: "apto" },
            },
            fecha_prox_revision: { $gte: new Date().toISOString() },
          });
          break;

        case "Apto a vigilar":
          filters.$and.push({
            revisiones: {
              active: true,
              estado: { $eq: "apto_a_vigilar" },
            },
            fecha_prox_revision: { $gte: new Date().toISOString() },
          });
          break;

        case "No apto":
          filters.$and.push({
            revisiones: {
              active: true,
              estado: { $eq: "no_apto" },
            },
          });
          break;

        case "Caducado":
          filters.$and.push({
            fecha_prox_revision: { $lte: new Date().toISOString() },
          });
          break;

        case "Con incidencia":
          filters.$and.push({
            incidencias: {
              estado_incidencia: {
                descripcion: { $eq: "abierta" },
              },
            },
          });
          break;

        case "Prox_Rev":
          filters.$and.push(
            { fecha_prox_revision: { $gt: new Date().toISOString() } },
            {
              fecha_prox_revision: {
                $lt: moment(new Date()).add(3, "months").toISOString(),
              },
            }
          );
          break;

        default:
          break;
      }
    },

    buildFilters(empresas, estado_kpi) {
      const filters = {
        $and: [
          ...(empresas.length > 0
            ? [
                {
                  empresa: {
                    id: { $in: empresas },
                  },
                },
              ]
            : []),
          { retirado: { $eq: true } },
        ],
      };

      if (this.query) {
        filters.$and.push({
          $or: [
            { division: { nombre: { $containsi: this.query } } },
            { subtipo: { nombre: { $containsi: this.query } } },
            { fabricante: { nombre: { $containsi: this.query } } },
            { modelo: { nombre: { $containsi: this.query } } },
            { numero_serie: { $containsi: this.query } },
            { numero_serie_qr: { $containsi: this.query } },
            { ubicacion: { $containsi: this.query } },
            { usuario: { username: { $containsi: this.query } } },
            { usuario: { nombre: { $containsi: this.query } } },
            { usuario: { apellidos: { $containsi: this.query } } },
          ],
        });
      }

      if (this.fdesde) {
        const newdate = this.fdesde.split("-").reverse().join("-");
        filters.$and.push({
          fecha_prox_revision: { $gt: newdate },
        });
      }

      if (this.fhasta) {
        const newdate = this.fhasta.split("-").reverse().join("-");
        filters.$and.push({
          fecha_prox_revision: { $lt: newdate },
        });
      }

      if (estado_kpi) {
        this.pushEstadoFilter(filters, estado_kpi);
      }

      if (this.estado) {
        this.pushEstadoFilter(filters, this.estado);
      }

      return filters;
    },

    getListDebounced: _.debounce(function () {
      try {
        if (!this.dashboardQuery) this.getList();
      } catch (error) {
        this.refreshPage();
      }
    }, 300),
    refreshPage() {
      console.log("refreshPage");
      this.dashboardQuery = false;
      location.reload(); // Reloads the current page
    },

    async loadStats() {
      const planta = localStorage.getItem("plantaSelected");
      const queryParams = {};

      if (planta >= 0) {
        queryParams.idEmpresa = planta;
      }

      try {
        const baseUrl =
          process.env.VUE_APP_API_BASE_URL ||
          "https://misepis-api.delfromsoftware.com/api";
        const response = await axios.get(`${baseUrl}/activos-retirados`, {
          params: queryParams,
        });

        const rawActivos = response.data.activos || [];
        this.totalActivos = rawActivos.length;

        if (response.data.stats) {
          this.totalCaducados = response.data.stats.revisionCaducada || 0;
          this.totalCaducan = response.data.stats.revisionProxima || 0;
          this.totalAptos = response.data.stats.aptos || 0;
          this.calculateAdditionalStats(rawActivos);
        } else {
          this.calculateAllStats(rawActivos);
        }
      } catch (error) {
        console.error("Error al obtener estadísticas de retirados:", error);
      }
    },

    async getList(estado_kpi) {
      const empresas = await this.resolveEmpresas();

      if (this.sort && this.sort.includes("data.attributes.")) {
        this.sort = this.sort.replace("data.attributes.", "");
      }

      const filters = this.buildFilters(empresas, estado_kpi);
      const params = {
        ...(this.sort ? { sort: this.sort } : {}),
        filters,
        pagination: {
          page: this.pagination.currentPage,
          pageSize: this.pagination.perPage,
        },
      };

      try {
        await this.$store.dispatch("activos/list", params).then(() => {
          this.activos = this.$store.getters["activos/list"];
          this.total = this.$store.getters["activos/listTotal"];
          this.loadingTable = false;
          this.fullscreenLoading = false;
        });

        await this.loadStats();
      } catch (error) {
        console.error("Error al obtener la lista de activos retirados:", error);
        this.loadingTable = false;
        this.fullscreenLoading = false;
        this.$notify({
          type: "danger",
          message: "Hubo un error al obtener la lista de equipos retirados.",
        });
      }
    },

    // Método para calcular estadísticas adicionales desde los datos recibidos
    calculateAdditionalStats(activos) {
      // Calcular estadísticas adicionales que no vienen del backend
      this.totalNoAptos = activos.filter(
        (activo) =>
          activo.revisiones?.length > 0 &&
          activo.revisiones[activo.revisiones.length - 1]?.estado === "no_apto"
      ).length;

      this.totalAptosAVigilar = activos.filter(
        (activo) =>
          activo.revisiones?.length > 0 &&
          activo.revisiones[activo.revisiones.length - 1]?.estado ===
            "apto_a_vigilar" &&
          moment(activo.fecha_prox_revision).isAfter(moment())
      ).length;
    },

    // Método para calcular todas las estadísticas localmente si el backend no las proporciona
    calculateAllStats(activos) {
      const today = moment();
      const threeMonthsFromNow = moment().add(3, "months");

      this.totalCaducados = activos.filter((activo) =>
        moment(activo.fecha_prox_revision).isBefore(today)
      ).length;

      this.totalCaducan = activos.filter(
        (activo) =>
          moment(activo.fecha_prox_revision).isAfter(today) &&
          moment(activo.fecha_prox_revision).isBefore(threeMonthsFromNow)
      ).length;

      this.totalAptos = activos.filter((activo) =>
        moment(activo.fecha_prox_revision).isAfter(threeMonthsFromNow)
      ).length;

      this.calculateAdditionalStats(activos);
    },

    // Función simplificada para estadísticas - ahora el backend las proporciona
    async getStats(empresas) {
      // Las estadísticas ahora vienen del endpoint principal,
      // solo necesitamos este método para compatibilidad
      console.log("Estadísticas obtenidas del endpoint principal");
    },

    async exportData() {
      this.loading = true;
      const empresas = await this.resolveEmpresas();

      if (this.sort && this.sort.includes("data.attributes.")) {
        this.sort = this.sort.replace("data.attributes.", "");
      }

      const filters = this.buildFilters(empresas);

      let params = {
        ...(this.sort ? { sort: this.sort } : {}),
        filters: filters,
        pagination: {
          page: this.pagination.currentPage,
          pageSize: this.pagination.perPage,
        },
      };

      await this.$store.dispatch("activos/list", params).then(async () => {
        let paramsExport = {
          ...(this.sort ? { sort: this.sort } : {}),

          filters: filters,
          pagination: {
            page: 1,
            pageSize: this.$store.getters["activos/listTotal"],
          },
        };

        await this.$store.dispatch("activos/list", paramsExport).then(() => {
          var items = this.$store.getters["activos/list"];

          console.log(items.length);

          var itemsFlatten = [];
          items.forEach((item) => {
            itemsFlatten.push(this.flattenObject(item));
          });

          console.log(itemsFlatten);

          this.itemsToExport = itemsFlatten;

          /* const elem = this.$refs.myBtn;
          elem.click(); */
          setTimeout(() => {
            this.$refs.myBtn.$el.click();
            this.loadingTable = false;
            this.loading = false;
          }, 500);
        });
      });
    },

    /* EXPORTACIÓN EXCEL */
    async fetchDataAndExportToExcel() {
      try {
        this.loading = true;
        const planta = localStorage.getItem("plantaSelected");
        const response = await axios.get(
          "https://misepis-api.delfromsoftware.com/api/activos-list?idEmpresa=" +
            planta
        );

        const activos = response.data.activos;
        // console.log("ACTIVOS: ", activos);

        const formattedData = this.formatData(activos);

        await this.exportToExcel(formattedData); // Asegúrate de usar await para que termine la exportación antes de seguir
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        // Esto se ejecutará independientemente de si hubo éxito o un error
        this.loading = false;
      }
    },
    async fetchSelectedAndExportToExcel() {
      try {
        this.loading = true;

        // Verificar si hay activos seleccionados
        if (this.multipleSelection.length === 0) {
          this.$notify({
            type: "warning",
            message: "No hay activos seleccionados.",
          });
          return;
        }

        // Obtener IDs de los activos seleccionados
        const selectedIds = this.multipleSelection.map((item) => item.id);

        // Cargar todos los activos de la planta
        const planta = localStorage.getItem("plantaSelected");
        const response = await axios.get(
          `https://misepis-api.delfromsoftware.com/api/activos-list?idEmpresa=${planta}`
        );

        const activos = response.data.activos;

        // Filtrar solo los activos seleccionados
        const selectedActivos = activos.filter((item) =>
          selectedIds.includes(item.id)
        );

        // Formatear datos
        const formattedData = this.formatData(selectedActivos);

        // Exportar a Excel
        await this.exportToExcel(formattedData);
      } catch (error) {
        console.error("Error exporting selected data:", error);
      } finally {
        this.loading = false;
      }
    },

    formatData(data) {
      return data.map((item) => {
        const hoy = moment();

        // Fecha de próxima revisión
        const fechaProximaRevision = item.fecha_prox_revision
          ? moment(item.fecha_prox_revision).toDate() // Devuelve Date
          : null;

        // Fecha de última revisión (1 año atrás)
        const fechaUltimaRevision = fechaProximaRevision
          ? moment(fechaProximaRevision).subtract(1, "years").toDate()
          : null;

        // Fecha de fabricación
        const fechaFabricacion = item.fecha_fabricacion
          ? moment(item.fecha_fabricacion).toDate()
          : null;

        // Fecha de puesta en servicio
        const fechaPuestaServicio = item.fecha_adquisicion
          ? moment(item.fecha_adquisicion).toDate()
          : null;

        // Obtener la última revisión primero
        const ultimaRevision =
          item.revisiones?.length > 0
            ? item.revisiones[item.revisiones.length - 1]
            : null;
        
        // Determinar el estado basándose en la fecha y la última revisión
        let estadoUltimaRevision = "Indefinido";
        
        if (fechaProximaRevision) {
          const fechaProximaMoment = moment(fechaProximaRevision);
          
          // Si la fecha de próxima revisión es anterior a hoy → "Caducado"
          if (fechaProximaMoment.isBefore(hoy, 'day')) {
            estadoUltimaRevision = "Caducado";
          } else {
            // Si la fecha es hoy o posterior → usar el estado de la última revisión
            if (ultimaRevision && ultimaRevision.estado_revision) {
              estadoUltimaRevision = ultimaRevision.estado_revision.nombre;
            } else {
              estadoUltimaRevision = "Indefinido";
            }
          }
        } else {
          // Si no hay fecha de próxima revisión, usar el estado de la última revisión o "Indefinido"
          if (ultimaRevision && ultimaRevision.estado_revision) {
            estadoUltimaRevision = ultimaRevision.estado_revision.nombre;
          } else {
            estadoUltimaRevision = "Indefinido";
          }
        }

        return {
          PLANTA: item.empresa?.alias || "No especificado",
          SUBTIPO: item.modelo?.subtipo?.nombre || "No especificado",
          MODELO: item.modelo?.nombre || "No especificado",
          FABRICANTE: item.modelo?.fabricante?.nombre || "No especificado",
          VIDA_UTIL: item.modelo?.vida_util || "No especificado",
          NUMERO_DE_SERIE: item.numero_serie,
          COLOR_PRECINTO: "ROJO",
          NUMERO_QR: item.numero_serie_qr || "",
          UBICACIÓN: item.ubicacion || "",
          USUARIO: item.usuario
            ? `${item.usuario.nombre} ${item.usuario.apellidos}`
            : "",
          FECHA_DE_FABRICACION: fechaFabricacion,
          FECHA_PUESTA_SERVICIO: fechaPuestaServicio,
          FECHA_REVISION: fechaUltimaRevision,
          PROXIMA_REVISION: fechaProximaRevision,
          ESTADO: estadoUltimaRevision,
          PDF_REVISION:
            "https://misepis-api.delfromsoftware.com/api/revision-download/" +
              ultimaRevision?.id || "No disponible",
        };
      });
    },
    exportToExcel(data) {
      const nombreXLS =
        data.length > 0 ? `EQUIPOS_${data[0].PLANTA}.xlsx` : "EQUIPOS.xlsx";

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("EQUIPOS");

      // Definir encabezados
      worksheet.columns = [
        { header: "PLANTA", key: "PLANTA", width: 30 },
        { header: "SUBTIPO", key: "SUBTIPO", width: 30 },
        { header: "MODELO", key: "MODELO", width: 30 },
        { header: "FABRICANTE", key: "FABRICANTE", width: 15 },
        { header: "VIDA ÚTIL", key: "VIDA_UTIL", width: 10 },
        { header: "NÚMERO DE SERIE", key: "NUMERO_DE_SERIE", width: 20 },
        {
          header: "FECHA DE FABRICACIÓN",
          key: "FECHA_DE_FABRICACION",
          width: 20,
        },
        {
          header: "PUESTA EN SERVICIO",
          key: "FECHA_PUESTA_SERVICIO",
          width: 20,
        },
        { header: "FECHA REVISIÓN", key: "FECHA_REVISION", width: 20 },
        { header: "PRÓXIMA REVISIÓN", key: "PROXIMA_REVISION", width: 20 },
        { header: "ESTADO", key: "ESTADO", width: 15 },
        { header: "PDF REVISIÓN", key: "PDF_REVISION", width: 30 },
      ];

      // Estilo del encabezado
      worksheet.getRow(1).eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FF0070C0" },
        };
        cell.font = { color: { argb: "FFFFFFFF" }, bold: true };
      });

      // Añadir filas
      data.forEach((item) => {
        const row = worksheet.addRow(item);

        // Aplicar formato de fecha solo a las celdas con fechas
        ["FECHA_DE_FABRICACION", "FECHA_PUESTA_SERVICIO", "FECHA_REVISION", "PROXIMA_REVISION"].forEach(
          (key) => {
            const cell = row.getCell(key);
            if (cell.value instanceof Date) {
              cell.numFmt = "dd/mm/yyyy";
            }
          }
        );

        // Formato condicional de ESTADO
        const estadoCell = row.getCell("ESTADO");
        if (estadoCell.value === "Apto") {
          estadoCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FF00FF00" }, // Verde
          };
        } else if (
          estadoCell.value === "No apto" ||
          estadoCell.value === "Caducado"
        ) {
          estadoCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFFF0000" }, // Rojo
          };
        }

        // PDF_REVISION como enlace
        const pdfCell = row.getCell("PDF_REVISION");
        if (pdfCell.value && pdfCell.value !== "No disponible") {
          pdfCell.value = {
            text: "Descargar",
            hyperlink: pdfCell.value,
          };
          pdfCell.font = { color: { argb: "FF0000FF" }, underline: true };
        }
      });

      // Generar y descargar el archivo
      workbook.xlsx
        .writeBuffer()
        .then((buffer) => {
          const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          saveAs(blob, nombreXLS);
        })
        .catch((err) => console.error("Error generating Excel file:", err));
    },
    exportSelectedToExcel() {
      if (this.multipleSelection.length === 0) {
        this.$notify({
          type: "warning",
          message: "No hay activos seleccionados.",
        });
        return;
      }

      // Formatea y exporta solo los activos seleccionados
      const formattedData = this.formatData(this.multipleSelection);
      this.exportToExcel(formattedData);
    },

    async deleteTipo(id) {
      if (this.$isDemo == 1 && ["1", "2"].includes(id)) {
        this.$notify({
          type: "danger",
          message: "You are not allowed not change data of default empresa.",
        });
        return;
      }
      try {
        const confirmation = await swal.fire({
          title: `Eliminar este equipo?`,
          type: "question",
          buttonsStyling: false,
          showCancelButton: true,
          confirmButtonText: "Sí, eliminar",
          cancelButtonText: "No, mantenerlo",
          confirmButtonClass: "btn btn-primary",
          cancelButtonClass: "btn btn-warning",
        });

        if (confirmation.value === true) {
          await this.$store.dispatch("activos/destroy", id);
          await this.getList();
          this.$notify({
            type: "success",
            message: "Equipo eliminado correctamente.",
          });
        }
      } catch (error) {
        if (error.response.data.errors[0]) {
          this.$notify({
            type: "danger",
            message: "This Empresa still has associated Items.",
          });
        } else {
          this.$notify({
            type: "danger",
            message: "Oops, something went wrong!",
          });
        }
      }
    },
    addDays(result, days) {
      result.setDate(result.getDate() + days);
      return result;
    },
    async getRevisores() {
      try {
        await this.$store.dispatch("profile/me");
        let me = await this.$store.getters["profile/me"];
        this.notificacion.usuario_origen.id = me.id;
        var meEmpresas = [];
        me.empresas.forEach((element) => {
          meEmpresas.push(element.id);
        });

        this.$store.dispatch("users/listLight").then(() => {
          var usuarios = cloneDeep(this.$store.getters["users/dropdownLight"]);

          usuarios.forEach((element) => {
            element.empresas.forEach((empresa) => {
              if (meEmpresas.includes(empresa.id)) {
                if (this.available_revisores.length == 0) {
                  this.available_revisores.push(element);
                }

                if (!this.checkIdRevisor(element.id)) {
                  console.log("ENTRA");
                  this.available_revisores.push(element);
                }
              }
            });
          });
        });
      } catch (error) {
        this.$notify({
          type: "danger",
          message: `Oops, something went wrong!`,
        });
        this.setApiValidation(error.response.data.errors);
      }
    },
    addTipo() {
      this.$router.push({ name: "Add Activo" });
    },
    viewTipo(row) {
      localStorage.setItem(
        "retiradosSearchState",
        JSON.stringify({
          query: this.query,
          fdesde: this.fdesde,
          fhasta: this.fhasta,
          estado: this.estado,
          currentPage: this.pagination.currentPage,
          perPage: this.pagination.perPage,
          selectedRows: this.multipleSelection,
        })
      );
      this.$router.push({
        name: "View Activo",
        params: { id: row.id },
      });
    },
    editTipo(row) {
      console.log(row);
      this.$router.push({
        name: "Edit Activo",
        params: { id: row.id },
      });
    },
    sortChange({ prop, order }) {
      if (prop === "usuario.data.attributes.nombre") {
        prop = "usuario.nombre";
      }

      if (order === "descending") {
        this.sort = `${prop}:desc`;
      } else if (order === "ascending") {
        this.sort = `${prop}:asc`;
      } else {
        this.sort = null;
      }
      this.getList();
    },

    showSwal(type) {
      if (type === "basic") {
        swal.fire({
          title: `Here's a message!`,
          text: `A few words about this sweet alert ...`,
          buttonsStyling: false,
          confirmButtonClass: "btn btn-primary",
        });
      } else if (type === "info") {
        swal.fire({
          icon: "info",
          title: `Info`,
          text: `A few words about this sweet alert ...`,
          buttonsStyling: false,
          confirmButtonClass: "btn btn-info",
        });
      } else if (type === "success") {
        this.fullscreenLoading = false;
        swal
          .fire({
            title: `¡Acción realizada correctamente!`,
            // text: 'Equipos entregados con éxito',
            buttonsStyling: false,
            confirmButtonClass: "btn btn-success",
            icon: "success",
          })
          .then(() => {
            this.$router.go(0);
          });
      } else if (type === "success_devueltos") {
        this.fullscreenLoading = false;
        swal
          .fire({
            title: `¡Equipos devueltos con éxito!`,
            text: "Los equipos quedan disponibles para asignarlos a otro usuario.",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-success",
            icon: "success",
          })
          .then(() => {
            this.$router.go(0);
          });
      } else if (type === "warning") {
        swal.fire({
          title: `Warning`,
          text: "A few words about this sweet alert ...",
          buttonsStyling: false,
          confirmButtonClass: "btn btn-warning",
          icon: "warning",
        });
      } else if (type === "question") {
        swal.fire({
          title: `Are you sure?`,
          text: "A few words about this sweet alert ...",
          buttonsStyling: false,
          confirmButtonClass: "btn btn-default",
          icon: "question",
        });
      }
    },
    getRowClass({ row }) {
      // Todos los activos en esta página están retirados
      return "retired-row";
    },
  },
};
</script>

<style scoped>
.kpi-container {
  display: flex;
  justify-content: space-between; /* Espacio equitativo entre los elementos */
  align-items: center; /* Centra verticalmente los elementos */
  flex-wrap: wrap; /* Permite que los elementos pasen a otra fila si es necesario */
  gap: 20px; /* Espacio entre elementos */
}

.kpi-item {
  flex: 1 1 calc(20% - 20px); /* Cada KPI ocupa el 20% del ancho, ajustado por el gap */
  max-width: calc(20% - 20px);
}

/* Estilos para activos retirados */
.el-table .retired-row {
  opacity: 0.85; /* Menos transparente en páginas de solo retirados */
  background-color: rgba(127, 16, 88, 0.05) !important;
}

.el-table .retired-row td {
  text-decoration: line-through;
  color: #555; /* Color más claro para contexto de solo retirados */
}

.el-table .retired-row .no-strike {
  text-decoration: none;
}

.el-table .retired-row .badge-retired {
  background-color: #666;
  color: white;
  text-decoration: none;
  padding: 0.25em 0.5em;
  font-size: 0.65em;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
}

.el-table .retired-row .retired-icon {
  opacity: 0.7;
  filter: grayscale(100%);
}

.el-table .retired-row .retired-icon.text-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}
</style>
